import React from "react";
import {Helmet} from "react-helmet-async";

const AnalysisPage = () => (
    <>
        <Helmet>
            <title>Analys</title>
        </Helmet>
        <div>
            <h1>Analys</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default AnalysisPage;
